import { addMonths } from 'date-fns';
import { IconButton } from 'modules/IconButton';
import { Falcon } from 'modules/macro';
import { useCalendar } from '../../Context';
export function NextMonthButton() {
    const { timeZone, locale, focusedDate, setFocusedDate, yearPickerVisible } = useCalendar();
    const nextMonth = addMonths(focusedDate, 1);
    const handleClick = () => setFocusedDate(nextMonth);
    const ariaFormat = new window.Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        timeZone,
    });
    if (yearPickerVisible) {
        return null;
    }
    return (<IconButton type="button" appearance="ghost" size="xs" aria-label={ariaFormat.format(nextMonth)} onClick={handleClick}>
      <Falcon icon="chevron-right"/>
    </IconButton>);
}
